module.exports = __webpack_public_path__ + "media/images/home-bg-72cca22948515f47a782e78586d1ef00.png";